import { Dimmer, Loader } from "semantic-ui-react";

export default function Spinner({loading}) {
    return (
        <Dimmer active={loading} inverted>
            <Loader inverted>Loading</Loader>
        </Dimmer>
    )
}